var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 32,
    viewBox: "0 0 14 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#4E88BF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M844.421 2353.595c2.244 0 3.87 2.14 3.302 4.307l-2.012 7.635c-.232.903-.464 2.063.748 2.14 1.238.078 2.915-.85 3.817-1.573 0 0 .207 2.27.207 2.296 0 .052-2.296 2.012-3.405 2.682-1.032.62-2.167 1.11-3.327 1.445-1.703.49-4.514 1.083-5.443-.98-.593-1.367-.206-3.121.13-4.514.025-.077 2.398-9.827 2.682-10.91.387-1.497 1.754-2.528 3.301-2.528zm2.662-12.595l.201.007c3.405.233 5.133 4.875 2.58 7.171-1.96 1.754-5.597 2.321-7.17-.232-.388-.645-.594-1.419-.568-2.193.077-2.63 2.605-4.9 5.158-4.746z",
    transform: "translate(-838 -2341)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfo);
export default __webpack_public_path__ + "static/media/icon-info.af1acc033aeb9f7474d19d310017db93.svg";
export { ForwardRef as ReactComponent };